import { Card, CardBody, Col } from 'reactstrap'
import { DefaultRangeSliders } from '../../../../Utils/Constants'
import DefaultRangeSliderForm from './DefaultRangeSliderForm'
import { defaultRangeData } from '../../../../Data/BonusUi/RangeSlider/RangeSlider'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const DefaultRangeSlider = () => {
  return (
    <Col lg="6">
      <Card>
        <CardHeaderCommon title={DefaultRangeSliders} span={defaultRangeData} />
        <CardBody>
          <DefaultRangeSliderForm />
        </CardBody>
      </Card>
    </Col>
  )
}

export default DefaultRangeSlider